import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../../../src/app/core/models/generic-models';
import { IBusinessDetailResponse } from '../models/business-detail.model';

export const loadGetBusinessDetails = createAction('[GetBusinessDetails] Load GetBusinessDetails', props<{ businessId: string }>());

export const loadGetBusinessDetailsSuccess = createAction(
  '[GetBusinessDetails] Load GetBusinessDetails Success',
  props<{ response: IBusinessDetailResponse[] }>()
);

export const loadGetBusinessDetailsFailure = createAction(
  '[GetBusinessDetails] Load GetBusinessDetails Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

export const clearGetBusinessDetailsResponse = createAction('[GetBusinessDetails] Clear GetBusinessDetails');
